export default __webpack_public_path__ + "apply3d722ab.png";